
import './modernizr.js'; // 'npm run modernizr' to create this file
import '../node_modules/jquery-slimscroll/jquery.slimscroll.js';




// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/vendor.ts